import React from 'react';
import { PoolTokenType } from "impermax-sdk";
import { Row, Col, Card } from 'react-bootstrap';
import BorrowableDetails from './BorrowableDetails';
import { formatUSD } from '../../utils/format';
import useGenericCall from '../../hooks/useGenericCall';
import PoolTokenContext from '../../contexts/PoolToken';
import { useOffchainCollateral } from '../../hooks/useOffchain';

import './index.scss';

export default function BorrowablesDetails() {
  const lpTokenLocked = useGenericCall(useOffchainCollateral(), offchainCollateral => offchainCollateral.getTotalBalanceUSD());
  if (lpTokenLocked > 0) console.log("LP Tokens locked:", formatUSD(lpTokenLocked));
  return (
    <div className="borrowables-details">
      <Row>
        <Col sm={6}>
          <Card>
            <Card.Body>
              <PoolTokenContext.Provider value={PoolTokenType.BorrowableA}>
                <BorrowableDetails />
              </PoolTokenContext.Provider>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={6}>
          <Card>
            <Card.Body>
              <PoolTokenContext.Provider value={PoolTokenType.BorrowableB}>
                <BorrowableDetails />
              </PoolTokenContext.Provider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}